import React from 'react'
import { storiesOf } from '@storybook/react'
import { action } from '@storybook/addon-actions'

import { QuizQuestion, IQuizQuestion, QuizAnswer } from 'protos'

import QuizCard from 'components/GameCard/components/QuizCard'

const questions: IQuizQuestion[] = [
  QuizQuestion.create({
    title: 'Who wins the match?',
    subtitle: 'Pick one answer.',
    questionId: 'q1',
    answer: [
      QuizAnswer.create({ answerId: 'a1', longText: 'Bayern München', shortText: '1' }),
      QuizAnswer.create({ answerId: 'a2', longText: 'draw', shortText: 'X' }),
      QuizAnswer.create({ answerId: 'a3', longText: 'Manchester United', shortText: '2' }),
    ],
  }),
  QuizQuestion.create({
    title: 'Who wins 1. half?',
    subtitle: 'Pick one answer.',
    questionId: 'q2',
    answer: [
      QuizAnswer.create({ answerId: 'a1', longText: 'Bayern München', shortText: '1' }),
      QuizAnswer.create({ answerId: 'a2', longText: 'draw', shortText: 'X' }),
      QuizAnswer.create({ answerId: 'a3', longText: 'Manchester United', shortText: '2' }),
    ],
  }),
  QuizQuestion.create({
    title: 'Kane to score 80pt',
    subtitle: 'Pick one answer.',
    questionId: 'q3',
    answer: [
      QuizAnswer.create({ answerId: 'a1', longText: 'over', shortText: 'over' }),
      QuizAnswer.create({ answerId: 'a2', longText: 'under', shortText: 'under' }),
    ],
  })
]

const onAnswer = (questionId: string, answerId: string) => new Promise<void>((resolve) => {
  setTimeout(() => {
    action('onAnswer')({ questionId, answerId })
    resolve(undefined)
  }, 1000)
})

const onError = (questionId: string, answerId: string) => new Promise<void>((resolve, reject) => {
  setTimeout(() => {
    action('onAnswer')({ questionId, answerId })
    reject(new Error)
  }, 1000)
})

storiesOf('GameCard/QuizCard', module)
  .addDecorator((story) => (
    <>
      <div style={{ padding: 32, backgroundColor: '#EEE' }}>{story()}</div>
      <div style={{ padding: 32, backgroundColor: '#EEE', width: 320, borderTop: '1px solid #AAA' }}>{story()}</div>
    </>
  ))
  .add('default', () => (
    <QuizCard
      onAnswer={onAnswer}
      onClose={action('onClose')}
      gameId="g1"
      homeTeam="Bayern München"
      awayTeam="Manchester United"
      questions={questions}
    />
  ))
  .add('error', () => (
    <QuizCard
      onAnswer={onError}
      onClose={action('onClose')}
      gameId="g2"
      homeTeam="Bayern München"
      awayTeam="Manchester United"
      questions={questions}
    />
  ))
  .add('first question is answered', () => (
    <QuizCard
      onAnswer={onAnswer}
      onClose={action('onClose')}
      gameId="g3"
      homeTeam="Bayern München"
      awayTeam="Manchester United"
      questions={questions.map((question, idx) => {
        if (idx === 0) {
          return { ...question, selectedAnswerId: 'a1' }
        }
        return question
      })}
    />
  ))
  .add('placeholder', () => (
    <QuizCard
      onAnswer={onAnswer}
      onClose={action('onClose')}
      gameId="g4"
      homeTeam="Bayern München"
      awayTeam="Manchester United"
      questions={questions.map((question, idx) => {
        if (idx === 2) {
          return { ...question, answer: [] }
        }
        return question
      })}
    />
  ))
  .add('readonly', () => (
    <QuizCard
      onClose={action('onClose')}
      gameId="g4"
      homeTeam="Bayern München"
      awayTeam="Manchester United"
      questions={questions.map((question, idx) => {
        if (idx === 0) {
          return { ...question, selectedAnswerId: 'a1', correctAnswerId: 'a1', editable: false }
        }
        if (idx === 2) {
          return { ...question, selectedAnswerId: 'a2', correctAnswerId: 'a3', editable: false }
        }

        return { ...question, editable: false }
      })}
      readonly
    />
  ))
